export type { LegalDoc, LegalSection } from './types';

export { privacyPolicy } from './privacy';
export { termsOfService } from './terms';
export { riskDisclosure } from './risk-disclosure';
export { refundPolicy } from './refunds';
export { grievancePolicy } from './grievance';
export { disclaimerDoc } from './disclaimer';
export { supportDoc } from './support';
export { deleteAccountDoc } from './delete-account';

import type { LegalDoc } from './types';
import { privacyPolicy } from './privacy';
import { termsOfService } from './terms';
import { riskDisclosure } from './risk-disclosure';
import { refundPolicy } from './refunds';
import { grievancePolicy } from './grievance';
import { disclaimerDoc } from './disclaimer';
import { supportDoc } from './support';
import { deleteAccountDoc } from './delete-account';

export const allLegalDocs: LegalDoc[] = [
  privacyPolicy,
  termsOfService,
  riskDisclosure,
  refundPolicy,
  grievancePolicy,
  disclaimerDoc,
  supportDoc,
  deleteAccountDoc,
];
